<template>
  <div :class="['my-steps', `is-${direction}`]" :style="cssVars">
    <div
      v-for="(step, index) in steps"
      :key="index"
      :class="['step-item', getStepStatus(index)]"
    >
      <!-- 线条 -->
      <div class="step-tail"></div>
      <!-- 图标/数字 -->
      <div class="step-icon">
        <span v-if="index < current">
          <img src="@/assets/style/stup-check-icon.png" alt="">
        </span>
        <span v-else>
          <img src="@/assets/style/stup-icon.png" alt="">
        </span>
      </div>
      <!-- 文本内容 -->
      <div class="step-content">
        <div class="step-title">{{ step.title }}</div>
        <div class="step-description" v-if="step.desc">{{ step.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MySteps',
  props: {
    steps: { type: Array, required: true },
    current: { type: Number, default: 0 },
    // 新增：方向属性，支持 horizontal (横向) 或 vertical (纵向)
    direction: {
      type: String,
      default: 'horizontal',
      validator: (val) => ['horizontal', 'vertical'].includes(val)
    },
    activeColor: { type: String, default: '#1890ff' },
    inactiveColor: { type: String, default: '#c0c4cc' },
    finishColor: { type: String, default: '#52c41a' },
  },
  computed: {
    cssVars() {
      return {
        '--active-color': this.activeColor,
        '--inactive-color': this.inactiveColor,
        '--finish-color': this.finishColor,
      };
    }
  },
  methods: {
    getStepStatus(index) {
      if (index < this.current) return 'is-finish';
      if (index === this.current) return 'is-active';
      return 'is-wait';
    }
  }
};
</script>

<style scoped lang="scss">
/* 基础公共样式 */
.my-steps {
  display: flex;
  font-family: Arial, sans-serif;
}
.step-item {
  position: relative;
  display: flex;
}
.step-icon {
  img{
    width: 16px;
    height: 16px;
  }
}
.step-tail {
  position: absolute;
  background-color: var(--inactive-color);
}
.step-content {
  color: #303133;
}
.step-title { font-size: 15px; }
.step-description { font-size: 12px; color: #909399; margin-top: 4px; }

/* ==========================================================================
   1. 横向布局样式 (Horizontal)
   ========================================================================== */
.my-steps.is-horizontal {
  flex-direction: row;
  width: 100%;
}
.my-steps.is-horizontal .step-item {
  flex: 1;
  flex-direction: column;
  align-items: center;
}
.my-steps.is-horizontal .step-tail {
  left: 50%;
  top: 16px;
  width: 100%;
  height: 2px;
  transform: translateX(50%);
}
.my-steps.is-horizontal .step-item:last-child .step-tail { display: none; }
.my-steps.is-horizontal .step-content {
  margin-top: 8px;
  text-align: center;
}

/* ==========================================================================
   2. 纵向布局样式 (Vertical)
   ========================================================================== */
.my-steps.is-vertical {
  flex-direction: column;
}
.my-steps.is-vertical .step-item {
  flex-direction: row;
  padding-bottom: 24px; /* 撑开步骤间的纵向距离 */
}
.my-steps.is-vertical .step-item:last-child {
  padding-bottom: 0;
}
.my-steps.is-vertical .step-tail {
  left: 7px;
  top: 16px;
  width: 2px;
  height: calc(100% - 16px); /* 自动拉伸至下一个节点 */
}
.my-steps.is-vertical .step-item:last-child .step-tail { display: none; }
.my-steps.is-vertical .step-content {
  margin-left: 12px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 24px;
  border-bottom: solid 1px #eeeeee;
}

/* ==========================================================================
   3. 状态级联样式
   ========================================================================== */
.step-item.is-finish .step-tail { background-color: var(--finish-color); }

.step-item.is-active .step-icon {
  border-color: var(--active-color);
  color: var(--active-color);
}
.step-item.is-active .step-title { font-weight: bold; }
.step-item.is-wait .step-title { color: #909399; }
.step-content :last-child{
  border-bottom: none !important;
}
</style>